import { render } from "./BatchCloseConfirmationDialog.vue?vue&type=template&id=0847adaf"
import script from "./BatchCloseConfirmationDialog.vue?vue&type=script&lang=js"
export * from "./BatchCloseConfirmationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__